import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from "./breadcrumbs.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from '@angular/material/icon';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatIconModule
    ],
  declarations: [
    BreadcrumbsComponent
  ],
  exports: [
    BreadcrumbsComponent
  ]
})
export class BreadcrumbsModule {}
